<template>
	<div class="supplier-modal" tabindex="0">

		<h3>CAP Commitment Form</h3>
		<h4>{{result.SupplierName}}</h4>
		<div class="terms">

			<h5>TERMS OF USE</h5>
			<p>
				I agree to participate in the LMC Co-op Assistance Program
				(CAP) for the above supplier.
			</p>
			<p>
				I agree to advertise the above Supplier's products in
				accordance with their published Co-op Advertising Program.
			</p>
			<p>
				I understand I am to receive from LMC accrued advertising
				funds as determined during the period covered by and in
				accordance with the Supplier's published plan.
			</p>
			<p>
				I will maintain a Proof of Performance file for 1 year for the above
				Supplier who may audit on my premises at their request.
			</p>
			<p>
				If I fail to use the advertising funds in accordance with the
				published plan to the satisfaction of the authorized representative
				of the supplier, I anticipate that I will be billed for an agreed
				upon amount, not to exceed the allowance received for the period,
				and LMC will return agreed upon amount to Supplier.
			</p>

		</div>
		<div class="terms-agree">
			<p>By clicking below, I confirm that I have read and agree to the Terms Of Use as stated above.</p>
			<button v-on:click="accept()" v-on:keydown.enter="accept()">I Agree</button>
			<button v-on:click="cancel()" v-on:keydown.enter="cancel()">Cancel</button>
		</div>

	</div>


</template>

<script>
	import * as ModalResponse from "../../common/modal-response";

	export default {
		props: {},
		data: function () {
			return {};
		},
		mounted() {
			$(".supplier-modal").focus();
		},
		methods: {
			accept: function () {
				this.removeDim();
				$('#program-' + this.result.itemID).focus();
				this.$close(ModalResponse.SUPPLIER_ADDED);
			},
			cancel: function () {
				this.removeDim();
				$('#program-' + this.result.itemID).focus();
				this.$close(ModalResponse.CANCELLED);
			},
			removeDim: function () {
				document.getElementsByTagName('body')[0].classList.remove('dim');
			}
		}
	};
</script>